import { ICellRendererAngularComp } from 'ag-grid-angular';
import { Component } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';


@Component({
    selector: 'app-evolution-renderer',
    template: `
    @if (value > 0) {
      <fa-icon icon="arrow-down-right" style="color: #1cb41c;"></fa-icon>
    }
    @if (value < 0) {
      <fa-icon icon="arrow-up-right" style="color: red"></fa-icon>
    }
    &nbsp;
    {{ valueFormatted }}
    `,
    standalone: true,
    imports: [FontAwesomeModule],
})
export class EvolutionRendererComponent implements ICellRendererAngularComp {
  public value: number;
  public valueFormatted: string;

  agInit(params: any): void {
    this.value = params?.value;
    this.valueFormatted = params?.valueFormatted;
  }

  refresh(): boolean {
    return false;
  }
}
